import React from 'react';
import PropTypes from "prop-types";
import Logo from '../../components/logo/Logo';
// import FooterData from '../../data/Footer/footerItem.json';
// import FooterLinkItem from '../../components/Footer/FooterLinkItem.jsx';
import { BASE_API_GAMBAR } from '../../config';

const Footer = ({logo, data}) => {
    return (
        <div className="footer-section section footer-bg-color">
            <div className="container">
                <div className="row mb-lg-14 mb-md-10">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 col-12" style={{display: "flex", justifyContent: "center"}}>
                        <div className="footer-widget">
                            <div className="footer-logo">
                                <Logo 
                                    image={`${BASE_API_GAMBAR}/${logo}`} width={"150px"}
                                />
                            </div>
                            <div className="footer-widget-content" style={{display: "flex", justifyContent: "center", marginTop: "-50px"}}>
                                <div className="content">
                                </div>
                                <div className="footer-social-inline">
                                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter-square"></i></a>
                                    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-square"></i></a>
                                    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* {FooterData && FooterData.map((single, key) => {
                            return(
                                <div key={key} className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mb-6">
                                    <FooterLinkItem data={single} key={key} />
                                </div>
                            ); 
                    })} */}


                </div>

                <div className="row">
                    <div className="col">
                        <p className="copyright">&copy; <strong>{data.name != "" ? data.name : ""}</strong></p>
                    </div>
                </div>

            </div>
        </div>
    )
}

Footer.propTypes = {
    logo: PropTypes.string,
    data: PropTypes.object
};

export default Footer
